import * as React from 'react';
import clsx from 'clsx';

import { FormParserContext } from 'src/contexts/form.context';
import { PrimaryButton as Button } from 'src/components/Button';

import classes from './PrimaryButton.module.scss';

export function PrimaryButton() {
  const { value, onChange, script, isDisabled, action } = React.useContext(FormParserContext);

  React.useLayoutEffect(() => {
    if (!value && script.isRequired) {
      onChange(new Date());
    }
  }, [onChange, script.isRequired, value]);

  function handleClick() {
    if (action) {
      action();
    }
  }

  return (
    <div className={clsx(classes.container, 'row a-center')}>
      <Button
        label={script.placeholder}
        rightIconId={script.rightIconId}
        onClick={handleClick}
        isDisabled={isDisabled}
        isPrevent
        isSmall
      />
    </div>
  );
}
